var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApolloQuery',{attrs:{"query":require('../graphql/CTFKryptonSolution.gql'),"update":_vm.computedData,"variables":{ level: _vm.lvl }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ref_result = ref.result;
var loading = ref_result.loading;
var error = ref_result.error;
var data = ref_result.data;
return [(loading)?_c('div',[_vm._v("Loading...")]):(error)?_c('div',[_vm._v("An error occured")]):(data)?_c('div',[_c('code-highlight',{attrs:{"lineNumbers":false}},[_vm._v(_vm._s(data))])],1):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }